import { type UseQueryResult, useQuery } from 'react-query';
import { GrantService } from '../../services/wealthlane-award-services';

const useGetGrantPlanNameList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantPlanNameList = useQuery(
    ['getGrantPlanNameList'],
    async () => {
      return await handleRequest(GrantService.getApiAwardApiAppGrantPlans());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.planName ?? '',
            value: item.planId ?? '',
          };
        });
      },
    }
  );

  return grantPlanNameList;
};

export default useGetGrantPlanNameList;
